import { Button } from "antd";
import classNames from "classnames";
import React, { CSSProperties, useState } from "react";
import CoreModal from "../InventoryOverview/modals/CoreModal";
import AddShipmentModal from "../InventoryOverview/modals/ShipmentModals/AddShipmentModal";
import { EmptyCard } from "./CardOrder/EmptryCard";
import { formatDateForOrderCard } from "./CardOrder/OrderCardCore";
import PoCard from "./CardOrder/PoCard";
import SoCard from "./CardOrder/SoCard";
import styles from "./styles.module.scss";
import { getStatusColor, mockData, Order } from "./utils";

interface InfoRowProps {
  label: string;
  value?: string;
  valueStyle?: CSSProperties;
  children?: React.ReactNode;
}

const InfoRow = ({ label, value, valueStyle, children }: InfoRowProps) => (
  <div className={styles.infoRow}>
    <label>{label}:</label>
    <p style={valueStyle}>{value || children}</p>
  </div>
);

const Scheduler = () => {
  const [selectedItem, setSelectedItem] = useState<{
    order: Order;
    index?: number;
  } | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addSoModalOpen, setAddSoModalOpen] = useState(false);
  const [actualSelect, setActualSelect] = useState(true);

  const handleViewOrders = (order: Order, index?: number) => {
    setSelectedItem({ order, index });
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedItem(null);
  };

  const modalContent = () => {
    if (selectedItem.index !== undefined) {
      const item = selectedItem.order.so[selectedItem.index];

      return (
        <div className={styles.modalContent}>
          <div className={styles.row}>
            <InfoRow label="Shipment Number" value="101" />
            <InfoRow
              label="Status"
              value={`${selectedItem.order.status}`}
              valueStyle={{
                textTransform: "capitalize",
                color: getStatusColor(selectedItem.order.status),
              }}
            />
          </div>

          <div className={styles.row}>
            <InfoRow label="Shipment Type" value="🚂 Train" />
            <InfoRow label="Shipment Cost" value="£3,500" />
          </div>

          <div className={styles.row}>
            <InfoRow label="Quantity" value="30,000" />
            <InfoRow
              label="Purchase Order Number"
              value="#73292"
              valueStyle={{
                textDecoration: "underline",
                color: "#5295E0",
              }}
            />
          </div>

          <div className={styles.row}>
            <InfoRow label="Ship-from location" value="Super supplement" />
            <InfoRow label="Destination" value="UK, Amazon UK main" />
          </div>

          <div className={styles.row}>
            <InfoRow
              label="Issue Date"
              value={formatDateForOrderCard(item.delivaryDate)}
            />
            <InfoRow
              label="Shipment Date"
              value={formatDateForOrderCard(item.shipmentDate)}
            />
          </div>

          <div className={styles.row}>
            <InfoRow
              label="Estimated Delivery Date"
              value={formatDateForOrderCard(item.delivaryDate)}
            />
            <InfoRow
              label="Actual Delivery Date"
              value={formatDateForOrderCard(item.shipmentDate)}
            />
          </div>
          <InfoRow label="ASINs">
            <div className={styles.asinBlock}>BOD15LQ983</div>
            <div className={styles.asinBlock}>BOD15LQ983</div>
            <div className={styles.asinBlock}>BOD15LQ983</div>
            <div className={styles.asinBlock}>BOD15LQ983</div>
          </InfoRow>
        </div>
      );
    } else {
      return (
        <div className={styles.modalContent}>
          <div className={styles.row}>
            <InfoRow
              label="Shipment Number"
              value={`£${selectedItem.order.po.cogs.toString()}`}
            />
            <InfoRow
              label="Status"
              value={`${selectedItem.order.status}`}
              valueStyle={{
                textTransform: "capitalize",
                color: getStatusColor(selectedItem.order.status),
              }}
            />
          </div>

          <div className={styles.row}>
            <InfoRow label="Fact" value="832 units" />
            <InfoRow label="Status" value="800 units (-32)" />
          </div>

          <div className={styles.row}>
            <InfoRow
              label="Order Date"
              value={formatDateForOrderCard(selectedItem.order.po.orderDate)}
            />
            <InfoRow
              label="Completion Date"
              value={formatDateForOrderCard(
                selectedItem.order.po.estCompleteDate,
              )}
            />
          </div>

          <div className={styles.row}>
            <InfoRow label="Supplier" value="Best Nutrition (id_123qwe)" />
            <InfoRow label="Shipment Type" value="🚂 Train" />
          </div>

          <div className={styles.row}>
            <InfoRow label="Shipment fees" value="£19,747" />
            <InfoRow label="DOI" value="21" />
          </div>
          <InfoRow label="Sales for the past 30 days" value="4,574" />
          <InfoRow label="ASINs">
            <div className={styles.asinBlock}>BOD15LQ983</div>
            <div className={styles.asinBlock}>BOD15LQ983</div>
            <div className={styles.asinBlock}>BOD15LQ983</div>
            <div className={styles.asinBlock}>BOD15LQ983</div>
          </InfoRow>
        </div>
      );
    }
  };

  return (
    <div className={styles.scheduler}>
      <div className={styles.filterBar}>
        <Button type="link" className={styles.viewButton}>
          See All PO
        </Button>
        <div className={styles.switch__container}>
          <button
            className={classNames(styles.switch, {
              [styles.active]: actualSelect,
            })}
            onClick={() => setActualSelect(true)}
          >
            Actual
          </button>
          <button
            className={classNames(styles.switch, {
              [styles.active]: !actualSelect,
            })}
            onClick={() => setActualSelect(false)}
          >
            History
          </button>
        </div>
      </div>
      <div className={styles.gridContainer}>
        <div className={styles.schedulerContainer}>
          <h1 className={styles.verticalText}>Scheduler</h1>
        </div>

        {mockData.map((order) => (
          <div key={order.id} className={styles.gridItem}>
            <div className={styles.columnItem}>
              <PoCard
                order={order.po}
                status={order.status}
                onViewClick={() => handleViewOrders(order)}
              />

              {order.so.length > 0 ? (
                order.so.map((so, index) => (
                  <SoCard
                    index={order.so.length >= 2 ? index + 1 : undefined}
                    key={so.id}
                    order={so}
                    status={order.status}
                    onViewClick={() => handleViewOrders(order, index)}
                  />
                ))
              ) : (
                <EmptyCard onClick={() => setAddSoModalOpen(true)} />
              )}
            </div>
          </div>
        ))}
      </div>
      {isModalOpen && (
        <CoreModal
          title={
            selectedItem.index === undefined
              ? `Purchase Order: #${selectedItem.order.po.id}`
              : `Shipment Order: #${selectedItem.order.so[selectedItem.index].id}`
          }
          open={isModalOpen}
          onCancel={handleCloseModal}
          withSaveButton={false}
          backButtonText="Cancel"
        >
          {modalContent()}
        </CoreModal>
      )}
      {addSoModalOpen && (
        <AddShipmentModal
          open={addSoModalOpen}
          onCancel={() => setAddSoModalOpen(false)}
        />
      )}
    </div>
  );
};

export default Scheduler;
